import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FeederContractModel } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { PowerGenerationSourceEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-feeder-contract-summary',
  templateUrl: './feeder-contract-summary.component.html',
  styleUrls: ['../../../shared/summaries/css-summary.component.scss']
})
export class FeederContractSummaryComponent implements OnInit, OnDestroy {
  @Input() feederContract: FeederContractModel;
  @Input() title: string;

  readonly PowerGenerationSourceEnum = PowerGenerationSourceEnum;

  private compUnsubs$ = new Subject<void>();

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
